module.exports = __webpack_public_path__ + "static/media/fm.38cf4667.svg";